module.exports = __webpack_public_path__ + "static/media/Quiz_Card_With_Text.f7f66470.png";